// react

// i18n
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

// i18n

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddCondition } from '../../forms/FormAddConditionWizard/FormAddConditionWizard';

// types
import { Condition } from '../../../@types';

// Props

export interface DialogAddConditionProps {
	condition?: Condition | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	preSelectedContext?: {
		activityId?: number;
		contractId?: number;
		workPlanId?: number;
	};
}

// Component

export const DialogAddCondition = ({
	condition,
	isOpen,
	onClose,
	onSuccess,
	preSelectedContext,
}: DialogAddConditionProps) => {
	// hooks
	const { t } = useTranslation();

	// derived

	// state
	const [, setIsLoading] = useState(false);

	return (
		<DialogActions
			hasClose={true}
			contentSx={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}
			isOpen={isOpen}
			maxWidth={800}
			onClose={onClose}
			title={{
				children: t('spendPlan.conditions.wizard.title'),
				variant: 'h3',
			}}>
			{isOpen && (
				<FormAddCondition
					condition={condition}
					onClose={onClose}
					onSuccess={onSuccess}
					preSelectedContext={preSelectedContext}
					setIsLoading={setIsLoading}
				/>
			)}
		</DialogActions>
	);
};
